import {classNames} from "shared/lib/classNames/classNames";
import cls from "./AppLink.module.scss";
import {Link, LinkProps, NavLink, NavLinkProps} from "react-router-dom";
import {FC} from "react";

export enum AppLinkTheme {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    ICON = "icon",
}

interface AppLinkProps extends NavLinkProps {
    className?: string;
    theme?: AppLinkTheme;
}

export const AppLink: FC<AppLinkProps> = (props) => {
    const {
        className,
        children,
        to,
        theme = AppLinkTheme.PRIMARY,
        ...rest
    } = props;
    return (
        <NavLink
            to={to}
            className={({isActive}) => classNames(cls.AppLink, {
                [cls.AppLink_active]: isActive
            }, [className, cls[theme]])}
            {...rest}
        >
            {children}
        </NavLink>
    )
};



